// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.filter .filter-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 20px;
}
.filter .filter-item select {
  width: 175px;
}

@media screen and (max-width: 1280px) {
  .filter-item {
    width: 33%;
  }
  .filter-item input {
    width: 150px !important;
  }
  .filter-item select {
    width: 150px !important;
  }
  .filter-item .dropdown-container {
    width: 150px !important;
  }
}
@media screen and (max-width: 800px) {
  .filter-item {
    flex-direction: column !important;
  }
}
@media screen and (max-width: 600px) {
  .filter {
    flex-direction: column !important;
    align-items: center !important;
  }
  .filter-item {
    flex-direction: column !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/filter/filter.styles.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACE,YAAA;AACN;;AAIA;EACE;IACE,UAAA;EADF;EAEE;IACE,uBAAA;EAAJ;EAEE;IACE,uBAAA;EAAJ;EAGE;IACE,uBAAA;EADJ;AACF;AAKA;EACE;IACE,iCAAA;EAHF;AACF;AAMA;EACE;IACE,iCAAA;IACA,8BAAA;EAJF;EAMA;IACE,iCAAA;EAJF;AACF","sourcesContent":[".filter {\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n\n  .filter-item {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    column-gap: 20px;\n\n    select {\n      width: 175px;\n    }\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .filter-item {\n    width: 33%;\n    input {\n      width: 150px !important;\n    }\n    select {\n      width: 150px !important;\n    }\n\n    .dropdown-container {\n      width: 150px !important;\n    }\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .filter-item {\n    flex-direction: column !important;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .filter {\n    flex-direction: column !important;\n    align-items: center !important;\n  }\n  .filter-item {\n    flex-direction: column !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
